<template>
  <div>
    <vs-popup :title="$t('Survey')" :active.sync="showModal">
      <form>
        <div class="vx-row">
          <div class="vx-col w-full">
            <!-- <vs-input
              class="inputx mb-4 mt-1"
             
              name="SurveyContent"
              :label="$t('SurveyContent')"
            /> -->
            <label for="">{{ $t("SurveyContent") }}:</label>
            <textarea
              v-model="model.content"
              name=""
              placeholder="نظرات ، پیشنهادات و انتقادات  خود را بنویسید..."
              rows="12"
              class="p-1 w-full"
            ></textarea>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-button
              type="filled"
              class="float-right mb-4"
              @click.prevent="submitForm"
              >{{ $t("Save") }}</vs-button
            >
          </div>
        </div>
      </form>
    </vs-popup>
  </div>
</template>
<style scoped>
textarea {
  font-family: "IRANSans", "IRANSans-Standard";
}
</style>
<script>
import { mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";

export default {
  name: "",
  props: {
    show: { default: false }
  },
  data() {
    return {
      isActive: true,
      model: {
        fullName: "",
        emailAddress: "",
        orderId: "",
        phone: "",
        header: "",
        content: ""
      }
    };
  },
  computed: {
    showModal: {
      get: function() {
        return this.show;
      },
      set: function() {
        this.$emit("finish");
      }
    }
  },
  methods: {
    ...mapActions({
      createSurvey: "forum/createSurvey"
    }),
    submitForm() {
      this.$swal({
        title: "آیا از ثبت این نظر اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر"
      }).then(result => {
        if (result.value) {
          this.createSurvey(this.model).then(() => {
            this.$swal({
              position: "center-center",
              type: "success",
              text: "رکورد مورد‌نظر با موفقیت ثبت شد!",
              showConfirmButton: false,
              timer: 2000
            });
            this.$emit("finish");
            this.model = {};
            this.$validator.reset();
          });
        }
      });
    }
  }
};
</script>
